// extracted by mini-css-extract-plugin
export default {"item":"ProcessItem_item__z8cGO","description":"ProcessItem_description__rFBmn","img_content":"ProcessItem_img_content__2EP0W"};